import CloseIcon from "@mui/icons-material/Close";
import { Modal, Avatar } from "@mui/material";
import "./BMXChatModal.scss";
import PropTypes from "prop-types";
import React, { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";

const BMXChatModal = (props) => {
  const {
    open,
    onClose,
    buttons,
    width,
    header,
    children,
    height,
    comments,
    maxHeight,
  } = props;

  const myModal = useRef();
  const commentsEndRef = useRef();
  const { t } = useTranslation();

  // Zamknięcie z animacją
  const closeModal = () => {
    const BMXChatModal = myModal.current;
    BMXChatModal?.classList.add("fadeOut");
    const timer = setTimeout(() => {
      onClose();
    }, 220);
    return () => clearTimeout(timer);
  };

  // Auto-scroll do ostatniego komentarza po załadowaniu komentarzy
  useEffect(() => {
    if (!comments || comments.length === 0) return;

    const id = requestAnimationFrame(() => {
      if (commentsEndRef.current) {
        commentsEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    });

    return () => cancelAnimationFrame(id);
  }, [comments]);

  return (
    <Modal
      onClose={closeModal}
      BackdropProps={{
        style: { backgroundColor: "transparent" },
      }}
      disableEnforceFocus
      open={open}
    >
      <div
        ref={myModal}
        className={`BMXChatModal ${open ? "fadeIn" : "fadeOut"}`}
        style={{ minWidth: width, maxHeight: maxHeight }}
      >
        <div className="Header">
          <span>{header}</span>
          <CloseIcon
            className="CloseIcon"
            fontSize="small"
            data-cy="closeModal"
            onClick={closeModal}
          />
        </div>

        <div className="Body" style={{ minHeight: height, maxWidth: width }}>
          <div
            style={{
              minHeight: "65%",
              overflowY: "auto",
            }}
          >
            <List>
              {comments?.map(
                ({ uuid, createdBy, createdAt, commentContent }) => (
                  <ListItem
                    key={uuid}
                    alignItems="flex-start"
                    disablePadding
                    sx={{ pr: 1 }}
                  >
                    <ListItemAvatar>
                      <Avatar
                        className="primary background"
                        alt="Avatar"
                        src={createdBy?.picture}
                      >
                        {createdBy?.firstName?.[0]?.toUpperCase() || ""}
                        {createdBy?.lastName?.[0]?.toUpperCase() || ""}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            color: "#333",
                          }}
                        >
                          {`${createdBy.firstName} ${createdBy.lastName}`}
                          <Typography
                            component="span"
                            style={{
                              fontSize: "0.8rem",
                              color: "#666",
                              marginLeft: "2px",
                            }}
                          >
                            {moment(createdAt).format("DD-MM-YYYY HH:mm")}
                          </Typography>
                        </Typography>
                      }
                      secondary={
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#333",

                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                          }}
                        >
                          {commentContent}
                        </Typography>
                      }
                    />
                  </ListItem>
                )
              )}
              {/* Znacznik końca listy do przewinięcia */}
              <div ref={commentsEndRef} />
            </List>
          </div>

          {children}
          {buttons}
        </div>
      </div>
    </Modal>
  );
};

BMXChatModal.defaultProps = {
  onClose: () => {},
  cancel: "global:cancel",
};

BMXChatModal.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  buttons: PropTypes.node,
  width: PropTypes.string,
  height: PropTypes.string,
  maxHeight: PropTypes.string,
  header: PropTypes.string,
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,
      createdBy: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        picture: PropTypes.string,
      }),
      createdAt: PropTypes.string,
      commentContent: PropTypes.string,
    })
  ),
};

export default BMXChatModal;
